/* generated by Svelte v3.31.0 */
import { SvelteComponent, binding_callbacks, create_slot, detach, element, init, insert, safe_not_equal, set_custom_element_data, transition_in, transition_out, update_slot } from "svelte/internal";
import { define } from "../lib";
import { VmControls } from "@vime/core";
import { createEventDispatcher, onMount } from "svelte";
function create_fragment(ctx) {
    let vm_controls;
    let current;
    const default_slot_template = /*#slots*/ ctx[23].default;
    const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[22], null);
    return {
        c() {
            vm_controls = element("vm-controls");
            if (default_slot)
                default_slot.c();
            set_custom_element_data(vm_controls, "class", /*className*/ ctx[0]);
            set_custom_element_data(vm_controls, "style", /*style*/ ctx[1]);
            vm_controls.hidden = /*hidden*/ ctx[2];
            set_custom_element_data(vm_controls, "full-width", /*fullWidth*/ ctx[3]);
            set_custom_element_data(vm_controls, "full-height", /*fullHeight*/ ctx[4]);
            set_custom_element_data(vm_controls, "direction", /*direction*/ ctx[5]);
            set_custom_element_data(vm_controls, "align", /*align*/ ctx[6]);
            set_custom_element_data(vm_controls, "justify", /*justify*/ ctx[7]);
            set_custom_element_data(vm_controls, "pin", /*pin*/ ctx[8]);
            set_custom_element_data(vm_controls, "active-duration", /*activeDuration*/ ctx[9]);
            set_custom_element_data(vm_controls, "wait-for-playback-start", /*waitForPlaybackStart*/ ctx[10]);
            set_custom_element_data(vm_controls, "hide-when-paused", /*hideWhenPaused*/ ctx[11]);
            set_custom_element_data(vm_controls, "hide-on-mouse-leave", /*hideOnMouseLeave*/ ctx[12]);
            set_custom_element_data(vm_controls, "is-audio-view", /*isAudioView*/ ctx[13]);
            set_custom_element_data(vm_controls, "is-settings-active", /*isSettingsActive*/ ctx[14]);
            set_custom_element_data(vm_controls, "playback-ready", /*playbackReady*/ ctx[15]);
            set_custom_element_data(vm_controls, "is-controls-active", /*isControlsActive*/ ctx[16]);
            set_custom_element_data(vm_controls, "paused", /*paused*/ ctx[17]);
            set_custom_element_data(vm_controls, "playback-started", /*playbackStarted*/ ctx[18]);
        },
        m(target, anchor) {
            insert(target, vm_controls, anchor);
            if (default_slot) {
                default_slot.m(vm_controls, null);
            }
            /*vm_controls_binding*/ ctx[24](vm_controls);
            current = true;
        },
        p(ctx, [dirty]) {
            if (default_slot) {
                if (default_slot.p && dirty & /*$$scope*/ 4194304) {
                    update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[22], dirty, null, null);
                }
            }
            if (!current || dirty & /*className*/ 1) {
                set_custom_element_data(vm_controls, "class", /*className*/ ctx[0]);
            }
            if (!current || dirty & /*style*/ 2) {
                set_custom_element_data(vm_controls, "style", /*style*/ ctx[1]);
            }
            if (!current || dirty & /*hidden*/ 4) {
                vm_controls.hidden = /*hidden*/ ctx[2];
            }
            if (!current || dirty & /*fullWidth*/ 8) {
                set_custom_element_data(vm_controls, "full-width", /*fullWidth*/ ctx[3]);
            }
            if (!current || dirty & /*fullHeight*/ 16) {
                set_custom_element_data(vm_controls, "full-height", /*fullHeight*/ ctx[4]);
            }
            if (!current || dirty & /*direction*/ 32) {
                set_custom_element_data(vm_controls, "direction", /*direction*/ ctx[5]);
            }
            if (!current || dirty & /*align*/ 64) {
                set_custom_element_data(vm_controls, "align", /*align*/ ctx[6]);
            }
            if (!current || dirty & /*justify*/ 128) {
                set_custom_element_data(vm_controls, "justify", /*justify*/ ctx[7]);
            }
            if (!current || dirty & /*pin*/ 256) {
                set_custom_element_data(vm_controls, "pin", /*pin*/ ctx[8]);
            }
            if (!current || dirty & /*activeDuration*/ 512) {
                set_custom_element_data(vm_controls, "active-duration", /*activeDuration*/ ctx[9]);
            }
            if (!current || dirty & /*waitForPlaybackStart*/ 1024) {
                set_custom_element_data(vm_controls, "wait-for-playback-start", /*waitForPlaybackStart*/ ctx[10]);
            }
            if (!current || dirty & /*hideWhenPaused*/ 2048) {
                set_custom_element_data(vm_controls, "hide-when-paused", /*hideWhenPaused*/ ctx[11]);
            }
            if (!current || dirty & /*hideOnMouseLeave*/ 4096) {
                set_custom_element_data(vm_controls, "hide-on-mouse-leave", /*hideOnMouseLeave*/ ctx[12]);
            }
            if (!current || dirty & /*isAudioView*/ 8192) {
                set_custom_element_data(vm_controls, "is-audio-view", /*isAudioView*/ ctx[13]);
            }
            if (!current || dirty & /*isSettingsActive*/ 16384) {
                set_custom_element_data(vm_controls, "is-settings-active", /*isSettingsActive*/ ctx[14]);
            }
            if (!current || dirty & /*playbackReady*/ 32768) {
                set_custom_element_data(vm_controls, "playback-ready", /*playbackReady*/ ctx[15]);
            }
            if (!current || dirty & /*isControlsActive*/ 65536) {
                set_custom_element_data(vm_controls, "is-controls-active", /*isControlsActive*/ ctx[16]);
            }
            if (!current || dirty & /*paused*/ 131072) {
                set_custom_element_data(vm_controls, "paused", /*paused*/ ctx[17]);
            }
            if (!current || dirty & /*playbackStarted*/ 262144) {
                set_custom_element_data(vm_controls, "playback-started", /*playbackStarted*/ ctx[18]);
            }
        },
        i(local) {
            if (current)
                return;
            transition_in(default_slot, local);
            current = true;
        },
        o(local) {
            transition_out(default_slot, local);
            current = false;
        },
        d(detaching) {
            if (detaching)
                detach(vm_controls);
            if (default_slot)
                default_slot.d(detaching);
            /*vm_controls_binding*/ ctx[24](null);
        }
    };
}
define("vm-controls", VmControls);
function instance($$self, $$props, $$invalidate) {
    let { $$slots: slots = {}, $$scope } = $$props;
    let __ref;
    let __mounted = false;
    const dispatch = createEventDispatcher();
    let { class: className } = $$props;
    let { style } = $$props;
    let { hidden = false } = $$props;
    let { fullWidth = false } = $$props;
    let { fullHeight = false } = $$props;
    let { direction = "row" } = $$props;
    let { align = "center" } = $$props;
    let { justify = "start" } = $$props;
    let { pin = "bottomLeft" } = $$props;
    let { activeDuration = 2750 } = $$props;
    let { waitForPlaybackStart = false } = $$props;
    let { hideWhenPaused = false } = $$props;
    let { hideOnMouseLeave = false } = $$props;
    let { isAudioView = false } = $$props;
    let { isSettingsActive = false } = $$props;
    let { playbackReady = false } = $$props;
    let { isControlsActive = false } = $$props;
    let { paused = true } = $$props;
    let { playbackStarted = false } = $$props;
    const ref = () => __ref;
    const getWebComponent = () => __ref;
    onMount(() => {
        __mounted = true;
    });
    const onEvent = e => {
        e.stopPropagation();
        dispatch(e.type, e.detail);
    };
    function vm_controls_binding($$value) {
        binding_callbacks[$$value ? "unshift" : "push"](() => {
            __ref = $$value;
            $$invalidate(19, __ref);
        });
    }
    $$self.$$set = $$props => {
        if ("class" in $$props)
            $$invalidate(0, className = $$props.class);
        if ("style" in $$props)
            $$invalidate(1, style = $$props.style);
        if ("hidden" in $$props)
            $$invalidate(2, hidden = $$props.hidden);
        if ("fullWidth" in $$props)
            $$invalidate(3, fullWidth = $$props.fullWidth);
        if ("fullHeight" in $$props)
            $$invalidate(4, fullHeight = $$props.fullHeight);
        if ("direction" in $$props)
            $$invalidate(5, direction = $$props.direction);
        if ("align" in $$props)
            $$invalidate(6, align = $$props.align);
        if ("justify" in $$props)
            $$invalidate(7, justify = $$props.justify);
        if ("pin" in $$props)
            $$invalidate(8, pin = $$props.pin);
        if ("activeDuration" in $$props)
            $$invalidate(9, activeDuration = $$props.activeDuration);
        if ("waitForPlaybackStart" in $$props)
            $$invalidate(10, waitForPlaybackStart = $$props.waitForPlaybackStart);
        if ("hideWhenPaused" in $$props)
            $$invalidate(11, hideWhenPaused = $$props.hideWhenPaused);
        if ("hideOnMouseLeave" in $$props)
            $$invalidate(12, hideOnMouseLeave = $$props.hideOnMouseLeave);
        if ("isAudioView" in $$props)
            $$invalidate(13, isAudioView = $$props.isAudioView);
        if ("isSettingsActive" in $$props)
            $$invalidate(14, isSettingsActive = $$props.isSettingsActive);
        if ("playbackReady" in $$props)
            $$invalidate(15, playbackReady = $$props.playbackReady);
        if ("isControlsActive" in $$props)
            $$invalidate(16, isControlsActive = $$props.isControlsActive);
        if ("paused" in $$props)
            $$invalidate(17, paused = $$props.paused);
        if ("playbackStarted" in $$props)
            $$invalidate(18, playbackStarted = $$props.playbackStarted);
        if ("$$scope" in $$props)
            $$invalidate(22, $$scope = $$props.$$scope);
    };
    return [
        className,
        style,
        hidden,
        fullWidth,
        fullHeight,
        direction,
        align,
        justify,
        pin,
        activeDuration,
        waitForPlaybackStart,
        hideWhenPaused,
        hideOnMouseLeave,
        isAudioView,
        isSettingsActive,
        playbackReady,
        isControlsActive,
        paused,
        playbackStarted,
        __ref,
        ref,
        getWebComponent,
        $$scope,
        slots,
        vm_controls_binding
    ];
}
class Controls extends SvelteComponent {
    constructor(options) {
        super();
        init(this, options, instance, create_fragment, safe_not_equal, {
            class: 0,
            style: 1,
            hidden: 2,
            fullWidth: 3,
            fullHeight: 4,
            direction: 5,
            align: 6,
            justify: 7,
            pin: 8,
            activeDuration: 9,
            waitForPlaybackStart: 10,
            hideWhenPaused: 11,
            hideOnMouseLeave: 12,
            isAudioView: 13,
            isSettingsActive: 14,
            playbackReady: 15,
            isControlsActive: 16,
            paused: 17,
            playbackStarted: 18,
            ref: 20,
            getWebComponent: 21
        });
    }
    $on(type, callback) {
        return super.$on(type, callback);
    }
    $set($$props) {
        super.$set($$props);
    }
    get ref() {
        return this.$$.ctx[20];
    }
    get getWebComponent() {
        return this.$$.ctx[21];
    }
}
export default Controls;
//# sourceMappingURL=Controls.js.map